// extracted by mini-css-extract-plugin
export default {"questionnaireWidth":"CourseEdit_questionnaireWidth__S7FqG","charcterLength":"CourseEdit_charcterLength__SqK4W","overColor":"CourseEdit_overColor__EsS1d"};